/**
 * abilityVfxDecisiveStrike — Garen Q Decisive Strike sword buff (SP-05).
 */
export function buildDecisiveStrike(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 1.2);
  const gold = mat(THREE, spec.color || 0xfacc15, 0.9);
  const steel = mat(THREE, 0xfef3c7, 0.95);
  addSword(THREE, group, s, gold, steel);
  addFootRingAndSpeed(THREE, group, s, gold);
  group.userData = { shape: 'decisive_strike' };
  return group;
}

function addSword(THREE, group, s, gold, steel) {
  const blade = new THREE.Mesh(new THREE.BoxGeometry(0.12 * s, 1.1 * s, 0.06 * s), steel);
  blade.position.y = 0.85 * s;
  group.add(blade);
  const tip = new THREE.Mesh(new THREE.ConeGeometry(0.1 * s, 0.28 * s, 4), gold);
  tip.position.y = 1.5 * s;
  group.add(tip);
  const hilt = new THREE.Mesh(new THREE.BoxGeometry(0.35 * s, 0.08 * s, 0.08 * s), gold);
  hilt.position.y = 0.28 * s;
  group.add(hilt);
}

function addFootRingAndSpeed(THREE, group, s, gold) {
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.5, s * 1.05, 20).rotateX(-Math.PI / 2),
    gold
  );
  ring.position.y = 0.06;
  group.add(ring);
  for (let i = 0; i < 2; i += 1) {
    const dash = new THREE.Mesh(new THREE.BoxGeometry(0.08 * s, 0.04 * s, 0.45 * s), gold);
    dash.position.set((i === 0 ? -1 : 1) * 0.55 * s, 0.35 * s, -0.15 * s);
    group.add(dash);
  }
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
